import fc from '@/firebaseConfig'

export default {
  namespaced: true,
  state: {
    loading: false,
    downloadingXml: false,
    downloadingPdf: false,
    downloadingMonthlyPdf: false,
    downloadStatus: {
      'pdf': {
        downloading: false,
        progress: '',
      },
      'xml': {
        downloading: false,
        progress: '',
      },
      'monthly': {
        downloading: false,
        progress: '',
      },
    },
  },
  mutations: {
    setDownloadingXml(state, val) {
      state.downloadingXml = val
    },
    setDownloadingPdf(state, val) {
      state.downloadingPdf = val
    },
    setDownloadProgress(state, { type, progress }) {
      state.downloadStatus[type].progress = progress
    },
    setDownloading(state, { type, downloading }) {
      state.downloadStatus[type].downloading = downloading
    },
  },
  actions: {
    create(context, {companyId, downloadedData}) {
      fc.companies.doc(companyId).collection('DocsDownloaded').add(
        {zipUrl: downloadedData.zipUrl, zipPath: downloadedData.zipPath, name: downloadedData.name, timeCreated: downloadedData.timeCreated, countXml: downloadedData.countXml}
      )
        .then(function () {})
        .catch(function (error) {
          console.log("error", error)
        })
    },
    updateDownloadingXml({commit}, {downloadingXml}) {
      commit('setDownloadingXml', downloadingXml)
    },
    updateDownloadingPdf({commit}, {downloadingPdf}) {
      commit('setDownloadingPdf', downloadingPdf)
    },
  },
}
